import React from "react";
import { Modal, Text } from "@networkraildigitalfactory/components";
import { useCloseObjectives } from "../../../hooks/closeObjectives";
import styles from "./CloseObjectivesModal.module.css";

const CloseObjectivesModal = ({ show, close, closeNotificationList }) => {
  const onCloseObjectives = useCloseObjectives(closeNotificationList, close);

  return (
    <Modal
      type="confirm"
      title="Close objectives"
      id="Close objectives"
      cancelText="Cancel"
      cancelButtonColor="red"
      confirmText="Close objectives"
      show={show}
      onClose={close}
      onConfirm={onCloseObjectives}
      style={{ maxWidth: "90%", width: "625px", position: "fixed" }}
    >
      <Text wrapper="h1" type="header" style={{ lineHeight: "140%", letterSpacing: "0.0015em" }}>
        Close objectives
      </Text>

      <Text wrapper="p" type="body">
        You have selected the following objectives to close:
      </Text>

      <div className={styles.listGroup}>
        <ul className={styles.list}>
          {closeNotificationList.map((objective, i) => (
            <li key={i}>
              <Text wrapper="span" type="body">
                {objective.label}
              </Text>
            </li>
          ))}
        </ul>
      </div>
      <Text wrapper="p" type="body">
        Once closed, these objectives cannot be edited or worked towards.
      </Text>
    </Modal>
  );
};

export default CloseObjectivesModal;
